
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funeral-recommend-item/[companyname]",
      function () {
        return require("private-next-pages/funeral-recommend-item/[companyname]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funeral-recommend-item/[companyname]"])
      });
    }
  